export default "__VITE_ASSET__Dy51aT7g__"